import {useEffect,useMemo} from 'react';
import HomeActionGrid from '../components/HomeActionGrid';
import PageShell from '../components/PageShell';
import ProfileBlock from '../components/ProfileBlock';
import useSiteContent from '../hooks/useSiteContent';
import {
  fallbackLinks,
  fallbackProfile,
  fallbackSocials
} from '../data/fallbackContent';
import {PROFILE_IMAGE_URL} from '../data/profileImage';
import {
  persistProfileImage,
  syncRecordsByUrl
} from '../services/siteContentService';

const profileImageUrl=PROFILE_IMAGE_URL;

const navigationActions=[
  {
    kind: 'portfolio',
    kicker: 'Selected work',
    title: 'Things I Have Built',
    description: 'AI projects,sites,music videos and experiments.',
    url: '#/portfolio'
  },
  {
    kind: 'amazon',
    kicker: 'Hand-picked gear',
    title: 'Amazon Finds',
    description: 'Useful creator gear,desk upgrades and everyday discoveries.',
    url: '#/amazon-finds'
  },
  {
    kind: 'music',
    kicker: 'Latest releases',
    title: 'Music Drops',
    description: 'Listen to the newest Dadda Cool tracks and experiments.',
    url: '#/music'
  },
  {
    kind: 'deals',
    kicker: 'Hand-picked software',
    title: 'Lifetime Deals',
    description: 'Selected lifetime software deals worth discovering.',
    url: '#/ltd'
  }
];

function mergeSocialChannels(existing,required) {
  const seenUrls=new Set();

  return [...existing,...required].filter((social)=> {
    const normalizedUrl=String(social.url || '')
      .trim()
      .replace(/\/$/,'')
      .toLowerCase();

    if (!normalizedUrl || seenUrls.has(normalizedUrl)) return false;
    seenUrls.add(normalizedUrl);
    return true;
  });
}

function findMatchingLink(links,action) {
  return links.find((link)=> {
    const url=String(link.url || '').toLowerCase();
    const title=String(link.title || '').toLowerCase();

    if (action.kind==='amazon') {
      return url.includes('amazon-finds') || title.includes('amazon find');
    }

    if (action.kind==='deals') {
      return url.includes('/ltd') || title.includes('deal');
    }

    if (action.kind==='music') {
      return url.includes('/music') || title.includes('music');
    }

    return url.includes('/portfolio') || title.includes('portfolio');
  });
}

export default function Home() {
  const {data: profiles}=useSiteContent('profile',fallbackProfile);
  const {data: socials}=useSiteContent('socials',fallbackSocials);
  const {data: links,refresh}=useSiteContent('links',fallbackLinks);

  useEffect(()=> {
    persistProfileImage(profileImageUrl,fallbackProfile[0]).catch(()=> {});
  },[]);

  useEffect(()=> {
    const amazonLink=fallbackLinks.find((link)=> link.id==='amazon-finds');
    if (!amazonLink) return;

    syncRecordsByUrl('links',[amazonLink])
      .then(()=> refresh())
      .catch(()=> {});
  },[refresh]);

  const visibleSocials=useMemo(
    ()=> mergeSocialChannels(socials,fallbackSocials),
    [socials]
  );

  const actions=useMemo(
    ()=> navigationActions.map((action)=> {
      const match=findMatchingLink(links,action);

      return {
        ...match,
        ...action,
        id: match?.id,
        click_count: match?.click_count,
        persisted: Boolean(match)
      };
    }),
    [links]
  );

  const currentProfile={
    ...(profiles[0] || fallbackProfile[0]),
    image_url: profileImageUrl
  };

  return (
    <PageShell>
      <ProfileBlock profile={currentProfile} socials={visibleSocials} />
      <HomeActionGrid actions={actions} />
    </PageShell>
  );
}